export default __webpack_public_path__ + "static/media/chef.02087052.svg";